import React from 'react'
import { HStack, VStack, Box, Image, Text, Button } from '@chakra-ui/react';
import b1 from '../img/book14/14-1.jpg';
import b2 from '../img/book14/14-2.jpg';
import b3 from '../img/book14/14-3.jpg';
import b4 from '../img/book14/14-4.jpg';
import b5 from '../img/book14/14-5.jpg';
import b6 from '../img/book14/14-6.jpg';
import b7 from '../img/book14/14-7.jpg';
import b8 from '../img/book14/14-8.jpg';
import b9 from '../img/book14/14-9.jpg';
import b10 from '../img/book14/14-10.jpg';
import b11 from '../img/book14/14-11.jpg';
import b12 from '../img/book14/14-12.jpg';
const Books14 = () => {
  return (
    <>
    <VStack spacing={4} align="stretch" alignItems={'center'} mt={4}>
      {/* ---------------------book1--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            borderColor="lightgray"
            bg={'#fff'}
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    إبراز قيمة المتاحف
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    دينا السيد عزيز
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    ستيفن ويل
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    عالم الغرب فلسفيًا
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    محمد رمضان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    جيمس ب. ساوث - ويليام ايروين
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            bg={'#fff'}
            borderRadius="10px"
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    استخدام الطريقة السقراطية في تقديم المشورة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د. ابتسام الخضراء
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    كاتارزينا بيبولز - آدم دروزديك
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book2--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    التعبير ببساطة
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    روان محمد عبدالواحد
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                        
                    جاي ساليفان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار: &nbsp;
                    <span>
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان: &nbsp;
                    <span>  
                    ما يفعله المعلمون الخبراء
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    محمد معوض سيد
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    جون لوغران
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    مداواة جراحك العاطفية والنفسية
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    أ.د. محيي الدين حميدي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    بيفرلي إينجل
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book3--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    وسائل التواصل الإجتماعي في مجال التعلم
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    مروان سعد الدين
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    كاثرين وزنياك - دانيال ر. تومال
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    التعليم خارج المألوف
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د. ابتسام الخضراء
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    د. باربرا أوكلي - د. بيث روغوفسكي - د. تيرنس جوزيف سجنو فسكي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    العمل حب مجسد
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    يمنى أحمد جمال الدين
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    فرانسيس هيسبلين - مارشال جولد سميث - سارة ماكارثر
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    العبيكان
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book4--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    كيف نفكر ونتعلم؟
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    درويش نايف عبد الهادي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    جين إليس أورمرود
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    مستثمر دهاندو
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    أسامة شاكر
                          </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    مونِش بابراي
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                 height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    تعلم كيف تتعلم
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    إيمان سمير
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    باربرا أوكلي ، تيرينس سيجنوفسكي ، أليستير ماكونفيل
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
    </VStack>
  </>
  )
}

export default Books14